<template>
  <div class="coop-p-survey">
    <nav class="coop-c-skip-nav">
      <ul class="coop-c-skip-nav__list">
        <li>
          <a
            class="coop-c-skip-nav__link"
            href="#main"
            title="Skip to content"
          >Skip to content</a>
        </li>
        <li>
          <a
            class="coop-c-skip-nav__link"
            href="#navigation"
            title="Skip to navigation"
          >Skip to navigation</a>
        </li>
      </ul>
    </nav>

    <aside class="ssn ssn-brandnav no-print">
      <div class="ssn-wrap ssn-brandnav-inner">
        <div class="ssn-bu-wrap">
          <button
            data-action="ssn-bu-toggle"
            class="ssn-bu-toggle"
            aria-expanded="false"
            aria-controls="ssn-bu-menu"
            aria-label="Show business menu"
            @click.prevent="mobileNavOpen = mobileNavOpen ? null : true"
          >
            Co-op
            <span
              class="ssn-chevron"
              aria-hidden="true"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 29 29"
              >
                <path d="M23.6 8.8c-.3 0-.6.1-.8.3l-8 8-.4.4-.4-.4-8-8c-.2-.1-.4-.3-.7-.3-.6 0-1.1.5-1.1 1.1 0 .3.1.6.3.8l9.2 9.1c.2.2.5.3.8.3.3 0 .6-.1.8-.3l9.2-9.1c.2-.2.3-.5.3-.8 0-.3-.1-.6-.3-.8-.3-.1-.6-.3-.9-.3z" />
              </svg>
            </span>
          </button>
          <nav
            id="ssn-bu-menu"
            class="ssn-bu-menu"
            :data-open="mobileNavOpen"
          >
            <ul>
              <li>
                <a
                  href="https://www.coop.co.uk/insurance?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                  data-linktext="Insurance"
                  data-contenttype="Header"
                  data-contentparent="Top links"
                  target="_blank"
                >Insurance</a>
              </li>
              <li>
                <a
                  href="https://www.co-oplegalservices.co.uk?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                  data-linktext="Legal Services"
                  data-contenttype="Header"
                  data-contentparent="Top links"
                  target="_blank"
                >Legal Services</a>
              </li>
              <li>
                <a
                  href="https://www.coop.co.uk/funeralcare?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                  data-linktext="Funeralcare"
                  data-contenttype="Header"
                  data-contentparent="Top links"
                  target="_blank"
                >Funeralcare</a>
              </li>
            </ul>
          </nav>
        </div>
        <nav class="ssn-ac-menu">
          <ul>
            <li>
              <a
                href="https://www.coop.co.uk/offers?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                data-linktext="Offers"
                data-contenttype="Header"
                data-contentparent="Top links"
                target="_blank"
              >Offers</a>
            </li>
            <li>
              <a
                href="https://www.coop.co.uk/membership?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                data-linktext="Join Co-op"
                data-contenttype="Header"
                data-contentparent="Top links"
                target="_blank"
              >Join Co-op</a>
            </li>
            <li>
              <a
                href="https://www.coop.co.uk/contact-us?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                data-linktext="Contact us"
                data-contenttype="Header"
                data-contentparent="Top links"
                target="_blank"
              >Contact us</a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
    <header class="ssn-header ssn">
      <nav aria-label="primary">
        <div class="ssn-header-inner ssn-wrap">
          <div class="ssn-logo">
            <a
              href="/"
              class="ssn-logo-link"
              data-contentparent="Actions"
              data-contenttype="Header"
              data-linktext="Co-op"
              target="_blank"
            >
              <svg
                width="38"
                height="40"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Co-op</title>
                <path
                  fill="#00B1E7"
                  d="M37.8 8.8c0-1.4-.2-2.8-.6-4.2-.5-1.7-1.8-3-3.4-3.7a14.9 14.9 0 0 0-10.2 0c-1.7.6-2.9 2-3.4 3.7-.8 2.8-.8 5.7 0 8.5.5 1.7 1.8 3 3.4 3.7 1.6.6 3.4.9 5.1.8 1.7 0 3.5-.3 5.1-.8 1.7-.6 2.9-2 3.4-3.7.4-1.5.6-2.9.6-4.3zm-5.5 0c0 .7-.1 1.4-.3 2-.3.9-1 1.6-2 1.8-.9.2-1.8.2-2.6 0-.9-.2-1.7-.8-2-1.8-.4-1.3-.4-2.8 0-4.1.3-.9 1-1.6 2-1.8.9-.2 1.8-.2 2.6 0 .9.2 1.7.8 2 1.8.2.7.3 1.4.3 2.1m-14.6 23c.8-2.8.8-5.7 0-8.5-.5-1.7-1.8-3-3.4-3.7a14.9 14.9 0 0 0-10.2 0c-1.7.6-2.9 2-3.4 3.7-.8 2.8-.8 5.7 0 8.5.5 1.7 1.8 3 3.4 3.7 3.3 1.2 6.9 1.2 10.2 0 1.6-.6 2.9-2 3.4-3.7m-4.9-4.2c0 .7-.1 1.4-.3 2-.3.9-1 1.6-2 1.8-.9.2-1.8.2-2.6 0-.9-.2-1.7-.8-2-1.8-.4-1.4-.4-2.8 0-4.1.3-.9 1-1.6 2-1.8.9-.2 1.8-.2 2.6 0 .9.2 1.7.8 2 1.8.2.7.3 1.4.3 2.1m0-18.9h5.5c0-1.4-.2-2.8-.6-4.2-.5-1.7-1.8-3-3.4-3.7C11-.3 7.4-.3 4.1.9c-1.7.6-2.9 2-3.4 3.7-.8 2.8-.8 5.7 0 8.5.5 1.7 1.8 3 3.4 3.7 1.6.6 3.4.8 5.1.8s3.5-.3 5.1-.8c1.7-.6 2.9-2 3.4-3.7.1-.2.1-.5.2-.7L12.7 10c-.1.3-.1.6-.2.9-.3.9-1 1.6-2 1.8-.9.2-1.8.2-2.6 0-.9-.2-1.7-.8-2-1.8-.4-1.4-.4-2.9 0-4.2.3-.9 1-1.6 2-1.8.9-.2 1.8-.2 2.6 0 .9.2 1.7.8 2 1.8.2.7.3 1.3.3 2m7.4 14.6c-.4 1.4-.6 2.8-.6 4.2V40h5.5V27.6c0-.7.1-1.4.3-2 .3-.9 1-1.6 2-1.8.9-.2 1.8-.2 2.6 0 .9.2 1.7.8 2 1.8.4 1.4.4 2.8 0 4.1-.3.9-1 1.6-1.9 1.8-.9.2-1.8.2-2.6 0-.2-.1-.4-.1-.5-.2l1.9 5.1c1.7 0 3.5-.3 5.1-.8 1.7-.6 2.9-2 3.4-3.7.8-2.8.8-5.7 0-8.5-.5-1.7-1.8-3-3.4-3.7a14.9 14.9 0 0 0-10.2 0c-1.9.6-3.1 2-3.6 3.6"
                />
              </svg>
            </a>
          </div>
        </div>
        <div
          id="navigation"
          class="ssn-mainnav"
          data-action="ssn-overlay-toggle"
        >
          <div class="ssn-mainnav-inner" />
        </div>
      </nav>
      <a href="#" @click.prevent="printPage" class="coop-u-white-bg coop-t-nounderline coop-c-hero__print">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.5 19H0.5V6H23.5V19H19" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19 16H5.5V22H19V16Z" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 6V3H20V6" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.5 10.5C3.77614 10.5 4 10.2761 4 10C4 9.72386 3.77614 9.5 3.5 9.5C3.22386 9.5 3 9.72386 3 10C3 10.2761 3.22386 10.5 3.5 10.5Z" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.5 9H21.5" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.5 11H21.5" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.5 10.5C6.77614 10.5 7 10.2761 7 10C7 9.72386 6.77614 9.5 6.5 9.5C6.22386 9.5 6 9.72386 6 10C6 10.2761 6.22386 10.5 6.5 10.5Z" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="coop-u-black">
          Print
        </span>
      </a>
    </header>

    <main
      id="main"
      class="coop-p-retirement-checklist"
    >
      <div class="coop-c-hero coop-c-hero--squircle coop-u-blue-dark-3-bg coop-u-white coop-u-margin-b-0">
        <div class="coop-c-hero__inner coop-u-clearfix coop-u-padding-resp-t-64-32">
          <h1 class="coop-c-hero__title">
            {{ filteredName }}, {{ mainTitle }}
          </h1>
          <div class="coop-c-hero__body">
            <p v-html="introCopy"></p>
          </div>
          <a href="#" @click.prevent="printPage" class="coop-u-white-bg coop-t-nounderline coop-c-hero__print">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 19H0.5V6H23.5V19H19" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19 16H5.5V22H19V16Z" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 6V3H20V6" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.5 10.5C3.77614 10.5 4 10.2761 4 10C4 9.72386 3.77614 9.5 3.5 9.5C3.22386 9.5 3 9.72386 3 10C3 10.2761 3.22386 10.5 3.5 10.5Z" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.5 9H21.5" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.5 11H21.5" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.5 10.5C6.77614 10.5 7 10.2761 7 10C7 9.72386 6.77614 9.5 6.5 9.5C6.22386 9.5 6 9.72386 6 10C6 10.2761 6.22386 10.5 6.5 10.5Z" stroke="#282828" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="coop-u-black">
              Print
            </span>
          </a>
        </div>
        <div
          class="coop-c-hero__decoration coop-c-hero__decoration--right no-print"
          aria-hidden="true"
        >
          <svg viewBox="0 0 246 302">
            <path
              d="M16.4112 -44.1113C43.1324 -85.0645 109.935 -101.039 161.345 -85.9358C213.044 -70.8325 249.641 -24.9418 293.499 16.0114C337.647 57.255 389.056 93.8515 400.093 141.485C411.42 189.118 382.085 247.789 337.937 276.834C293.789 305.878 235.119 305.007 185.742 295.422C136.657 286.128 96.5749 268.12 69.8536 239.075C42.842 210.321 28.9005 170.239 15.5398 117.087C2.17924 63.9353 -10.6005 -2.86768 16.4112 -44.1113Z"
              fill="#519AF5"
            />
          </svg>
        </div>
      </div>

      <div class="coop-c-page">
        <div class="coop-l-container">
          <div class="coop-l-grid">
            <div class="coop-l-grid__item coop-l-grid__item--large-8">
              <div class="coop-c-will-card coop-u-blue-light-10-bg">
                <img
                  src="dist/images/notes-icon-1x.png"
                  srcset="dist/images/notes-icon-1x.png 1x, dist/images/notes-icon-2x.png 2x"
                  alt="Wills"
                  class="coop-c-will-card__icon"
                >
                <div class="coop-c-will-card__content">
                  <h4>Wills</h4>
                  <p v-html="willsCallout" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="coop-l-container coop-u-padding-resp-t-48-24">
          <div class="coop-l-grid">
            <div class="coop-l-grid__item coop-l-grid__item--large-10">
              <h2>Your retirement checklist</h2>
              <p>The checklist is based on the information you have provided. Use the checklist by ticking off steps you have completed and those not relevant to you. You will then have actionable next steps which may help you plan for retirement and the future.</p>
              <p>We do not give advice or recommendations on retirement planning, pensions, or investments. If this is needed it is best to contact your provider or an independent financial adviser.</p>
            </div>
          </div>
        </div>
        <div class="coop-l-container coop-u-padding-resp-t-48-24">
          <div class="coop-l-grid">
            <div class="coop-l-grid__item coop-l-grid__item--large-10 coop-c-checklist-group__wrapper">
              <div class="coop-c-checklist-group">
                <h3>Thinking about retirement</h3>
                <fieldset
                  v-for="(item, index) in surveyStore.checkboxOptions.slice(0, 2)"
                  :key="index"
                  class="coop-form__row"
                >
                  <div class="coop-form__choice coop-u-margin-b-16">
                    <input
                      :id="`q${index}`"
                      v-model="surveyStore.surveyResult.checkboxes[index]"
                      type="checkbox"
                      :name="`q${index}`"
                      class="coop-form__field coop-form__checkbox"
                    >
                    <label
                      class="coop-form__label"
                      :for="`q${index}`"
                    >{{ item.label }}</label>
                    <p
                      class="coop-form__hint"
                      v-html="item.hint"
                    />
                  </div>
                </fieldset>
              </div>
              <div class="coop-c-checklist-group">
                <h3>Decide when to retire</h3>
                <fieldset
                  v-for="(item) in surveyStore.checkboxOptions.slice(2, 5).concat(surveyStore.checkboxOptions[16])"
                  :key="item.index"
                  v-show="!item?.hide"
                  class="coop-form__row"
                >
                  <div class="coop-form__choice coop-u-margin-b-16">
                    <input
                      :id="`q${item.index}`"
                      v-model="surveyStore.surveyResult.checkboxes[item.index]"
                      type="checkbox"
                      :name="`q${item.index}`"
                      class="coop-form__field coop-form__checkbox"
                    >
                    <label
                      class="coop-form__label"
                      :for="`q${item.index}`"
                    >{{ item.label }}</label>
                    <p
                      class="coop-form__hint"
                      v-html="item.hint"
                    />
                  </div>
                </fieldset>
              </div>
              <div class="coop-c-checklist-group">
                <h3>Protect your future and your loved ones</h3>
                <fieldset
                  v-for="(item, index) in surveyStore.checkboxOptions.slice(5, 11)"
                  v-show="!item?.hide"
                  :key="index + 5"
                  class="coop-form__row"
                >
                  <div class="coop-form__choice coop-u-margin-b-16">
                    <input
                      :id="`q${index + 5}`"
                      v-model="surveyStore.surveyResult.checkboxes[index + 5]"
                      type="checkbox"
                      :name="`q${index + 5}`"
                      class="coop-form__field coop-form__checkbox"
                    >
                    <label
                      class="coop-form__label"
                      :for="`q${index + 5}`"
                    >{{ item.label }}</label>
                    <p
                      class="coop-form__hint"
                      v-html="item.hint"
                    />
                  </div>
                </fieldset>
              </div>
              <div class="coop-c-checklist-group">
                <h3>An active retirement</h3>
                <p>Retirement is a big adjustment and it's natural to feel a bit lost or unsure of how to make the most of your new free time. There's no right or wrong way to spend retirement, but there are ways to make sure you're getting the most out of it.</p>
                <fieldset
                  v-for="(item, index) in surveyStore.checkboxOptions.slice(11, 16)"
                  :key="index + 11"
                  v-show="!item?.hide"
                  class="coop-form__row"
                >
                  <div class="coop-form__choice coop-u-margin-b-16">
                    <input
                      :id="`q${index + 11}`"
                      v-model="surveyStore.surveyResult.checkboxes[index + 11]"
                      type="checkbox"
                      :name="`q${index + 11}`"
                      class="coop-form__field coop-form__checkbox"
                    >
                    <label
                      class="coop-form__label"
                      :for="`q${index + 11}`"
                    >{{ item.label }}</label>
                    <p
                      class="coop-form__hint"
                      v-html="item.hint"
                    />
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
        <div class="coop-l-container coop-u-padding-resp-t-48-24 coop-u-padding-resp-b-64-32 no-print">
          <h3 class="coop-u-margin-resp-b-24-12">
            Want to save your checklist?
          </h3>
          <div class="coop-c-checklist-buttons">
            <button
              class="coop-btn coop-btn--primary"
              @click.prevent="printPage"
            >
              Print
            </button>
            <button
              class="coop-btn"
              @click.prevent="downloadPDF"
            >
              Download
            </button>
          </div>
        </div>
      </div>
      <div class="coop-u-flex coop-u-flex-column">
        <div class="coop-u-brand-bg coop-u-padding-b-16" />
        <div class="coop-u-padding-resp-b-64-32 coop-u-padding-resp-t-48-24 no-print">
          <div class="coop-l-section__inner coop-l-container">
            <h2 class="coop-l-section__heading">
              Help from our members
            </h2>
            <p>Retirement can feel like entering the unknown but our members have some practical ideas to help and answer your questions.</p>
            <div class="coop-u-margin-resp-t-48-24">
              <div class="coop-b-card-carousel">
                <a
                  href="#"
                  class="coop-b-card-carousel__control coop-b-card-carousel__control--prev b2"
                  data-action="ssn-swiper-prev"
                >
                  <svg
                    width="57"
                    height="57"
                    viewBox="0 0 57 57"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="29"
                      cy="29"
                      r="24"
                      fill="#DDE9ED"
                    />
                    <path
                      d="M38.1334 29.6798L21.5642 29.6798L28.7947 36.6778C28.8606 36.7411 28.9129 36.8163 28.9486 36.8992C28.9842 36.982 29.0026 37.0709 29.0026 37.1607C29.0026 37.2505 28.9842 37.3394 28.9486 37.4222C28.9129 37.5051 28.8606 37.5803 28.7947 37.6436C28.6631 37.7702 28.485 37.8413 28.2994 37.8413C28.1137 37.8413 27.9356 37.7702 27.804 37.6436L19.3718 29.4826C19.3059 29.4194 19.2537 29.3442 19.218 29.2613C19.1823 29.1784 19.164 29.0895 19.164 28.9997C19.164 28.91 19.1823 28.8211 19.218 28.7382C19.2537 28.6553 19.3059 28.5801 19.3718 28.5169L27.804 20.3559C27.9349 20.2303 28.1115 20.1594 28.2958 20.1587C28.3883 20.1582 28.48 20.1753 28.5656 20.2092C28.6512 20.243 28.7291 20.2929 28.7947 20.3559C28.8606 20.4191 28.9129 20.4944 28.9486 20.5772C28.9842 20.6601 29.0026 20.749 29.0026 20.8388C29.0026 20.9286 28.9842 21.0174 28.9486 21.1003C28.9129 21.1832 28.8606 21.2584 28.7947 21.3216L21.5571 28.3197L38.1334 28.3197C38.3197 28.3197 38.4985 28.3913 38.6302 28.5188C38.762 28.6464 38.836 28.8194 38.836 28.9997C38.836 29.1801 38.762 29.3531 38.6302 29.4806C38.4985 29.6082 38.3197 29.6798 38.1334 29.6798Z"
                      fill="#6E6E6E"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M27.6884 37.7561C27.8508 37.9123 28.0704 38 28.2994 38C28.5282 38 28.7478 37.9124 28.9102 37.7562C28.9914 37.6782 29.0559 37.5855 29.0999 37.4833C29.1439 37.3811 29.1666 37.2714 29.1666 37.1607C29.1666 37.05 29.1439 36.9403 29.0999 36.8381C29.056 36.736 28.9916 36.6433 28.9105 36.5654L21.96 29.8385L38.1334 29.8385C38.3632 29.8385 38.5836 29.7501 38.7462 29.5928C38.9087 29.4355 39 29.2222 39 28.9997C39 28.7773 38.9087 28.5639 38.7462 28.4066C38.5836 28.2493 38.3632 28.161 38.1334 28.161L21.9532 28.161L28.9102 21.4343C28.9913 21.3564 29.0559 21.2635 29.0999 21.1613C29.1439 21.0591 29.1666 20.9495 29.1666 20.8388C29.1666 20.728 29.1439 20.6184 29.0999 20.5162C29.0559 20.414 28.9914 20.3212 28.9102 20.2433C28.8292 20.1655 28.7332 20.104 28.6276 20.0623C28.522 20.0205 28.409 19.9994 28.2949 20C28.0676 20.001 27.8499 20.0884 27.6885 20.2433L19.2564 28.4042C19.1752 28.4821 19.1106 28.5751 19.0667 28.6772C19.0227 28.7794 19 28.889 19 28.9997C19 29.1105 19.0227 29.2201 19.0667 29.3223C19.1106 29.4244 19.175 29.5171 19.2561 29.595L27.6884 37.7561ZM27.9196 37.531L19.4877 29.3704C19.4373 29.3219 19.3967 29.2638 19.3693 29.2003C19.342 29.1367 19.3279 29.0686 19.3279 28.9997C19.3279 28.9309 19.342 28.8628 19.3693 28.7992C19.3967 28.7357 19.4368 28.678 19.4873 28.6295L27.9194 20.4686C28.0197 20.3725 28.1554 20.318 28.2965 20.3174C28.3674 20.317 28.438 20.3301 28.5036 20.3561C28.5692 20.382 28.6289 20.4203 28.6793 20.4686C28.7298 20.5171 28.7699 20.5747 28.7972 20.6383C28.8246 20.7018 28.8386 20.7699 28.8386 20.8388C28.8386 20.9076 28.8246 20.9758 28.7972 21.0393C28.7699 21.1028 28.7298 21.1605 28.6793 21.209L21.161 28.4783L38.1334 28.4783C38.2762 28.4783 38.4133 28.5333 38.5143 28.6311C38.6153 28.7288 38.6721 28.8615 38.6721 28.9997C38.6721 29.138 38.6153 29.2706 38.5143 29.3684C38.4133 29.4662 38.2762 29.5211 38.1334 29.5211L21.1683 29.5211L28.6788 36.79C28.7293 36.8385 28.7699 36.8966 28.7972 36.9602C28.8246 37.0237 28.8386 37.0919 28.8386 37.1607C28.8386 37.2295 28.8246 37.2977 28.7972 37.3612C28.7699 37.4247 28.7298 37.4824 28.6793 37.5309C28.5784 37.628 28.4417 37.6826 28.2994 37.6826C28.1571 37.6826 28.0205 37.628 27.9196 37.531Z"
                      fill="#6E6E6E"
                    />
                  </svg>
                </a>
                <swiper-container
                  :slides-per-view="1.4"
                  :breakpoints="{
                    768: {
                      slidesPerView: 1
                    }
                  }"
                  :space-between="24"
                  navigation-next-el=".coop-b-card-carousel__control--next.b2"
                  navigation-prev-el=".coop-b-card-carousel__control--prev.b2"
                  :auto-height="true"
                  :observer="true"
                  :observe-parents="true"
                  ref="swiperInvolved"
                >
                  <swiper-slide
                    class="coop-b-card-carousel__slide coop-u-padding-resp-32-16 coop-u-radius-8 coop-u-f9fbff-bg"
                  >
                    <h3>Get involved</h3>
                    <p class="coop-t-font-size-24">
                      "I have taken up volunteering for a number of causes: our community orchard, road safety group, repair cafe, and am actively pursuing learning of new languages (principally Portuguese) and reviving my acoustic guitar playing"
                    </p>
                    <p class="coop-t-font-size-18 coop-u-text-alt">
                      Alan<br>
                      Scotland
                    </p>
                  </swiper-slide>
                  <swiper-slide
                    class="coop-b-card-carousel__slide coop-u-padding-resp-32-16 coop-u-radius-8 coop-u-f9fbff-bg"
                  >
                    <h3>Take time for yourself</h3>
                    <p class="coop-t-font-size-24">
                      "I spend more time in the garden and have started to grow some vegetables. I'm also cooking more from scratch rather than buying ready prepared vegetables etc."
                    </p>
                    <p class="coop-t-font-size-18 coop-u-text-alt">
                      Jean<br>
                      North West
                    </p>
                  </swiper-slide>
                  <swiper-slide
                    class="coop-b-card-carousel__slide coop-u-padding-resp-32-16 coop-u-radius-8 coop-u-f9fbff-bg"
                  >
                    <h3>Try new things</h3>
                    <p class="coop-t-font-size-24">
                      "I would say - go for it! Join some local groups such as the U3A and take part in activities eg join a choir, a walking group, book group, sports club etc. It is important to have some focus during the week. Try out a few things to find something that you would like to do. Meet up with friends and relatives. Go out for the day. Do lots of different things to keep your mind and body active."
                    </p>
                    <p class="coop-t-font-size-18 coop-u-text-alt">
                      Elaine<br>
                      North West
                    </p>
                  </swiper-slide>
                  <swiper-slide
                    class="coop-b-card-carousel__slide coop-u-padding-resp-32-16 coop-u-radius-8 coop-u-f9fbff-bg"
                  >
                    <h3>See what's available </h3>
                    <p class="coop-t-font-size-24">
                      "I think getting good financial advice was critical to ensuring I could meet my financial needs. So if you can, pay off your mortgage and if you can, continue to save regularly. Check out any benefits you might be entitled to. Also there are lots of freebies for older people, like free bus pass etc."
                    </p>
                    <p class="coop-t-font-size-18 coop-u-text-alt">
                      Jatinder<br>
                      West Midlands
                    </p>
                  </swiper-slide>
                </swiper-container>
                <a
                  href="#"
                  class="coop-b-card-carousel__control coop-b-card-carousel__control--next b2"
                  data-action="ssn-swiper-next"
                >
                  <svg
                    width="57"
                    height="57"
                    viewBox="0 0 57 57"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="28"
                      cy="28"
                      r="24"
                      transform="rotate(180 28 28)"
                      fill="#80B7FF"
                    />
                    <path
                      d="M18.8666 27.3202H35.4358L28.2053 20.3222C28.1394 20.2589 28.0871 20.1837 28.0514 20.1008C28.0158 20.018 27.9974 19.9291 27.9974 19.8393C27.9974 19.7495 28.0158 19.6606 28.0514 19.5778C28.0871 19.4949 28.1394 19.4197 28.2053 19.3564C28.3369 19.2298 28.515 19.1587 28.7006 19.1587C28.8863 19.1587 29.0644 19.2298 29.196 19.3564L37.6282 27.5174C37.6941 27.5806 37.7463 27.6558 37.782 27.7387C37.8177 27.8216 37.836 27.9105 37.836 28.0003C37.836 28.09 37.8177 28.1789 37.782 28.2618C37.7463 28.3447 37.6941 28.4199 37.6282 28.4831L29.196 36.6441C29.0652 36.7697 28.8885 36.8406 28.7042 36.8413C28.6117 36.8418 28.52 36.8247 28.4344 36.7908C28.3488 36.757 28.2709 36.7071 28.2053 36.6441C28.1394 36.5809 28.0871 36.5056 28.0514 36.4228C28.0158 36.3399 27.9974 36.251 27.9974 36.1612C27.9974 36.0714 28.0158 35.9826 28.0514 35.8997C28.0871 35.8168 28.1394 35.7416 28.2053 35.6784L35.4429 28.6803H18.8666C18.6803 28.6803 18.5015 28.6087 18.3698 28.4812C18.238 28.3536 18.164 28.1806 18.164 28.0003C18.164 27.8199 18.238 27.6469 18.3698 27.5194C18.5015 27.3918 18.6803 27.3202 18.8666 27.3202Z"
                      fill="#282828"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M29.3116 19.2439C29.1492 19.0877 28.9296 19 28.7006 19C28.4718 19 28.2522 19.0876 28.0898 19.2438C28.0086 19.3218 27.9441 19.4145 27.9001 19.5167C27.8561 19.6189 27.8334 19.7286 27.8334 19.8393C27.8334 19.95 27.8561 20.0597 27.9001 20.1619C27.944 20.264 28.0084 20.3567 28.0895 20.4346L35.04 27.1615H18.8666C18.6368 27.1615 18.4164 27.2499 18.2538 27.4072C18.0913 27.5645 18 27.7778 18 28.0003C18 28.2227 18.0913 28.4361 18.2538 28.5934C18.4164 28.7507 18.6368 28.839 18.8666 28.839H35.0468L28.0898 35.5657C28.0087 35.6436 27.9441 35.7365 27.9001 35.8387C27.8561 35.9409 27.8334 36.0505 27.8334 36.1612C27.8334 36.272 27.8561 36.3816 27.9001 36.4838C27.9441 36.586 28.0086 36.6788 28.0898 36.7567C28.1708 36.8345 28.2668 36.896 28.3724 36.9377C28.478 36.9795 28.591 37.0006 28.7051 37C28.9324 36.999 29.1501 36.9116 29.3115 36.7567L37.7436 28.5958C37.8248 28.5179 37.8894 28.4249 37.9333 28.3228C37.9773 28.2206 38 28.111 38 28.0003C38 27.8895 37.9773 27.7799 37.9333 27.6777C37.8894 27.5756 37.825 27.4829 37.7439 27.405L29.3116 19.2439ZM29.0804 19.469L37.5123 27.6296C37.5627 27.6781 37.6033 27.7362 37.6307 27.7997C37.658 27.8633 37.6721 27.9314 37.6721 28.0003C37.6721 28.0691 37.658 28.1372 37.6307 28.2008C37.6033 28.2643 37.5632 28.322 37.5127 28.3705L29.0806 36.5314C28.9803 36.6275 28.8446 36.682 28.7035 36.6826C28.6326 36.683 28.562 36.6699 28.4964 36.6439C28.4308 36.618 28.3711 36.5797 28.3207 36.5314C28.2702 36.4829 28.2301 36.4253 28.2028 36.3617C28.1754 36.2982 28.1614 36.2301 28.1614 36.1612C28.1614 36.0924 28.1754 36.0242 28.2028 35.9607C28.2301 35.8972 28.2702 35.8395 28.3207 35.791L35.839 28.5217H18.8666C18.7238 28.5217 18.5867 28.4667 18.4857 28.3689C18.3847 28.2712 18.3279 28.1385 18.3279 28.0003C18.3279 27.862 18.3847 27.7294 18.4857 27.6316C18.5867 27.5338 18.7238 27.4789 18.8666 27.4789H35.8317L28.3212 20.21C28.2707 20.1615 28.2301 20.1034 28.2028 20.0398C28.1754 19.9763 28.1614 19.9081 28.1614 19.8393C28.1614 19.7705 28.1754 19.7023 28.2028 19.6388C28.2301 19.5753 28.2702 19.5176 28.3207 19.4691C28.4216 19.372 28.5583 19.3174 28.7006 19.3174C28.8429 19.3174 28.9795 19.372 29.0804 19.469Z"
                      fill="#282828"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          id="guides"
          class="coop-u-blue-dark-3-bg coop-u-white coop-u-padding-resp-b-64-32 coop-u-padding-resp-t-48-24 no-print"
        >
          <div class="coop-l-section__inner coop-l-container">
            <h2 class="coop-l-section__heading coop-u-padding-resp-b-24-12">
              Find out more
            </h2>
            <div class="coop-b-card-carousel">
              <a
                href="#"
                class="coop-b-card-carousel__control coop-b-card-carousel__control--prev b1"
                data-action="ssn-swiper-prev"
              >
                <svg
                  width="57"
                  height="57"
                  viewBox="0 0 57 57"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="29"
                    cy="29"
                    r="24"
                    fill="#DDE9ED"
                  />
                  <path
                    d="M38.1334 29.6798L21.5642 29.6798L28.7947 36.6778C28.8606 36.7411 28.9129 36.8163 28.9486 36.8992C28.9842 36.982 29.0026 37.0709 29.0026 37.1607C29.0026 37.2505 28.9842 37.3394 28.9486 37.4222C28.9129 37.5051 28.8606 37.5803 28.7947 37.6436C28.6631 37.7702 28.485 37.8413 28.2994 37.8413C28.1137 37.8413 27.9356 37.7702 27.804 37.6436L19.3718 29.4826C19.3059 29.4194 19.2537 29.3442 19.218 29.2613C19.1823 29.1784 19.164 29.0895 19.164 28.9997C19.164 28.91 19.1823 28.8211 19.218 28.7382C19.2537 28.6553 19.3059 28.5801 19.3718 28.5169L27.804 20.3559C27.9349 20.2303 28.1115 20.1594 28.2958 20.1587C28.3883 20.1582 28.48 20.1753 28.5656 20.2092C28.6512 20.243 28.7291 20.2929 28.7947 20.3559C28.8606 20.4191 28.9129 20.4944 28.9486 20.5772C28.9842 20.6601 29.0026 20.749 29.0026 20.8388C29.0026 20.9286 28.9842 21.0174 28.9486 21.1003C28.9129 21.1832 28.8606 21.2584 28.7947 21.3216L21.5571 28.3197L38.1334 28.3197C38.3197 28.3197 38.4985 28.3913 38.6302 28.5188C38.762 28.6464 38.836 28.8194 38.836 28.9997C38.836 29.1801 38.762 29.3531 38.6302 29.4806C38.4985 29.6082 38.3197 29.6798 38.1334 29.6798Z"
                    fill="#6E6E6E"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M27.6884 37.7561C27.8508 37.9123 28.0704 38 28.2994 38C28.5282 38 28.7478 37.9124 28.9102 37.7562C28.9914 37.6782 29.0559 37.5855 29.0999 37.4833C29.1439 37.3811 29.1666 37.2714 29.1666 37.1607C29.1666 37.05 29.1439 36.9403 29.0999 36.8381C29.056 36.736 28.9916 36.6433 28.9105 36.5654L21.96 29.8385L38.1334 29.8385C38.3632 29.8385 38.5836 29.7501 38.7462 29.5928C38.9087 29.4355 39 29.2222 39 28.9997C39 28.7773 38.9087 28.5639 38.7462 28.4066C38.5836 28.2493 38.3632 28.161 38.1334 28.161L21.9532 28.161L28.9102 21.4343C28.9913 21.3564 29.0559 21.2635 29.0999 21.1613C29.1439 21.0591 29.1666 20.9495 29.1666 20.8388C29.1666 20.728 29.1439 20.6184 29.0999 20.5162C29.0559 20.414 28.9914 20.3212 28.9102 20.2433C28.8292 20.1655 28.7332 20.104 28.6276 20.0623C28.522 20.0205 28.409 19.9994 28.2949 20C28.0676 20.001 27.8499 20.0884 27.6885 20.2433L19.2564 28.4042C19.1752 28.4821 19.1106 28.5751 19.0667 28.6772C19.0227 28.7794 19 28.889 19 28.9997C19 29.1105 19.0227 29.2201 19.0667 29.3223C19.1106 29.4244 19.175 29.5171 19.2561 29.595L27.6884 37.7561ZM27.9196 37.531L19.4877 29.3704C19.4373 29.3219 19.3967 29.2638 19.3693 29.2003C19.342 29.1367 19.3279 29.0686 19.3279 28.9997C19.3279 28.9309 19.342 28.8628 19.3693 28.7992C19.3967 28.7357 19.4368 28.678 19.4873 28.6295L27.9194 20.4686C28.0197 20.3725 28.1554 20.318 28.2965 20.3174C28.3674 20.317 28.438 20.3301 28.5036 20.3561C28.5692 20.382 28.6289 20.4203 28.6793 20.4686C28.7298 20.5171 28.7699 20.5747 28.7972 20.6383C28.8246 20.7018 28.8386 20.7699 28.8386 20.8388C28.8386 20.9076 28.8246 20.9758 28.7972 21.0393C28.7699 21.1028 28.7298 21.1605 28.6793 21.209L21.161 28.4783L38.1334 28.4783C38.2762 28.4783 38.4133 28.5333 38.5143 28.6311C38.6153 28.7288 38.6721 28.8615 38.6721 28.9997C38.6721 29.138 38.6153 29.2706 38.5143 29.3684C38.4133 29.4662 38.2762 29.5211 38.1334 29.5211L21.1683 29.5211L28.6788 36.79C28.7293 36.8385 28.7699 36.8966 28.7972 36.9602C28.8246 37.0237 28.8386 37.0919 28.8386 37.1607C28.8386 37.2295 28.8246 37.2977 28.7972 37.3612C28.7699 37.4247 28.7298 37.4824 28.6793 37.5309C28.5784 37.628 28.4417 37.6826 28.2994 37.6826C28.1571 37.6826 28.0205 37.628 27.9196 37.531Z"
                    fill="#6E6E6E"
                  />
                </svg>
              </a>
              <swiper-container
                :slides-per-view="1.4"
                :breakpoints="{
                  768: {
                    slidesPerView: 3.4
                  }
                }"
                :space-between="24"
                navigation-next-el=".coop-b-card-carousel__control--next.b1"
                navigation-prev-el=".coop-b-card-carousel__control--prev.b1"
              >
                <swiper-slide
                  v-if="!surveyStore.surveyResult.checkboxes[5] || surveyStore.surveyResult.products.length >= 6"
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.co-oplegalservices.co.uk/making-a-will/do-i-need-a-will/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/WhatYouNeed.jpg"
                              srcset="/dist/images/cards/WhatYouNeed.jpg 1x, /dist/images/cards/WhatYouNeed@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="What you need to make a will"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                What you need to make a will
                              </span>
                            </h3>
                          </header>
                          <!--div class="coop-c-editorialcard__body">
                            <p>Placeholder text.</p>
                          </div-->
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide>
                <swiper-slide
                  v-if="!surveyStore.surveyResult.checkboxes[5] || surveyStore.surveyResult.products.length >= 6"
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.co-oplegalservices.co.uk/making-a-will/understanding-the-costs/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/what-is-a-lpa.jpg"
                              srcset="/dist/images/cards/what-is-a-lpa.jpg 1x, /dist/images/cards/what-is-a-lpa@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="Cost of making a will"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                Cost of making a will
                              </span>
                            </h3>
                          </header>
                          <!--div class="coop-c-editorialcard__body">
                            <p>Placeholder text.</p>
                          </div-->
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide>
                <!-- <swiper-slide
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.co-oplegalservices.co.uk/media-centre/articles-may-aug-2017/what-makes-a-will-invalid/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/what-is-a-life-insurance.jpg"
                              srcset="/dist/images/cards/what-is-a-life-insurance.jpg 1x, /dist/images/cards/what-is-a-life-insurance@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="What makes a Will invalid"
                              style="opacity: .5"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                What makes a Will invalid
                              </span>
                            </h3>
                          </header>
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide> -->
                <swiper-slide
                  v-if="!surveyStore.surveyResult.checkboxes[9] || surveyStore.surveyResult.products.length >= 6"
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.coop.co.uk/funeralcare/funeral-plans/what-is-a-funeral-plan?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/WhatisaFuneralPlan.jpg"
                              srcset="/dist/images/cards/WhatisaFuneralPlan.jpg 1x, /dist/images/cards/WhatisaFuneralPlan@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="What is a funeral plan?"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                What is a funeral plan?
                              </span>
                            </h3>
                          </header>
                          <!--div class="coop-c-editorialcard__body">
                            <p>Placeholder text.</p>
                          </div-->
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide>
                <swiper-slide
                  v-if="!surveyStore.surveyResult.checkboxes[9] || surveyStore.surveyResult.products.length >= 6"
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.coop.co.uk/funeralcare/advice/funeral-plans-good-idea?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/HowdoFuneralPlanswork.jpg"
                              srcset="/dist/images/cards/HowdoFuneralPlanswork.jpg 1x, /dist/images/cards/HowdoFuneralPlanswork@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="How do funeral plans work"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                How do funeral plans work?
                              </span>
                            </h3>
                          </header>
                          <!--div class="coop-c-editorialcard__body">
                            <p>Placeholder text.</p>
                          </div-->
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide>
                <swiper-slide
                  v-if="!surveyStore.surveyResult.checkboxes[8] || surveyStore.surveyResult.products.length >= 6"
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.co-oplegalservices.co.uk/making-a-will/lasting-powers-of-attorney/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/WhatisaLPA.jpg"
                              srcset="/dist/images/cards/WhatisaLPA.jpg 1x, /dist/images/cards/WhatisaLPA@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="What is a lasting power of attorney (LPA)?"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                What is a lasting power of attorney (LPA)?
                              </span>
                            </h3>
                          </header>
                          <!-- <div class="coop-c-editorialcard__body">
                            <p>Applying for a Lasting Power of Attorney can be a tough process. Here's our guide to make it easier for you.</p>
                          </div> -->
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide>
                <swiper-slide
                  v-if="!surveyStore.surveyResult.checkboxes[8] || surveyStore.surveyResult.products.length >= 6"
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.co-oplegalservices.co.uk/media-centre/articles-jan-apr-2016/top-tips-for-putting-a-lasting-power-of-attorney-in-place/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/TopTipsforLPA.jpg"
                              srcset="/dist/images/cards/TopTipsforLPA.jpg 1x, /dist/images/cards/TopTipsforLPA@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="Top Tips for Putting a Lasting Power of Attorney in Place"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                Top Tips for Putting a Lasting Power of Attorney in Place
                              </span>
                            </h3>
                          </header>
                          <!-- <div class="coop-c-editorialcard__body">
                            <p>Placeholder text.</p>
                          </div> -->
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide>
                <swiper-slide
                  v-if="!surveyStore.surveyResult.checkboxes[7] || surveyStore.surveyResult.products.length >= 6"
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.coop.co.uk/insurance/life-cover/life-insurance?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning#what-is"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/what-is-a-life-insurance.jpg"
                              srcset="/dist/images/cards/what-is-a-life-insurance.jpg 1x, /dist/images/cards/what-is-a-life-insurance@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="Life insurance explained"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                Life insurance explained
                              </span>
                            </h3>
                          </header>
                          <!-- <div class="coop-c-editorialcard__body">
                            <p>Life insurance is cover designed to pay out money if you pass away. It can be used for things such as paying off a mortgage or other debts.</p>
                          </div> -->
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide>

                <swiper-slide
                  v-if="!surveyStore.surveyResult.checkboxes[10] || surveyStore.surveyResult.products.length >= 6"
                  class="coop-b-card-carousel__slide"
                >
                  <article class="coop-c-editorialcard">
                    <a
                      href="https://www.coop.co.uk/insurance/lifetime-mortgages?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                      class="coop-c-editorialcard__link"
                      data-contenttype="Card|Editorial"
                      data-contentparent=""
                      data-linktext=""
                      target="_blank"
                    >
                      <div class="coop-c-editorialcard__inner">
                        <figure class="coop-c-editorialcard__media">
                          <picture class="coop-c-editorialcard__image">
                            <img
                              src="/dist/images/cards/what-is-a-lifetime-mortgage.jpg"
                              srcset="/dist/images/cards/what-is-a-lifetime-mortgage.jpg 1x, /dist/images/cards/what-is-a-lifetime-mortgage@2x.jpg 2x"
                              width="294"
                              height="204"
                              alt="What is a lifetime mortgage?"
                            >
                          </picture>
                        </figure>
                        <div class="coop-c-editorialcard__content">
                          <header class="coop-c-editorialcard__header">
                            <h3 class="coop-c-editorialcard__title">
                              <span>
                                What is a lifetime mortgage?
                              </span>
                            </h3>
                          </header>
                          <!-- <div class="coop-c-editorialcard__body">
                            <p>Lifetime mortgages, also known as equity release, can be a way to access value from your property.</p>
                          </div> -->
                        </div>
                      </div>
                    </a>
                  </article>
                </swiper-slide>
              </swiper-container>
              <a
                href="#"
                class="coop-b-card-carousel__control coop-b-card-carousel__control--next b1"
                data-action="ssn-swiper-next"
              >
                <svg
                  width="57"
                  height="57"
                  viewBox="0 0 57 57"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="28"
                    cy="28"
                    r="24"
                    transform="rotate(180 28 28)"
                    fill="#80B7FF"
                  />
                  <path
                    d="M18.8666 27.3202H35.4358L28.2053 20.3222C28.1394 20.2589 28.0871 20.1837 28.0514 20.1008C28.0158 20.018 27.9974 19.9291 27.9974 19.8393C27.9974 19.7495 28.0158 19.6606 28.0514 19.5778C28.0871 19.4949 28.1394 19.4197 28.2053 19.3564C28.3369 19.2298 28.515 19.1587 28.7006 19.1587C28.8863 19.1587 29.0644 19.2298 29.196 19.3564L37.6282 27.5174C37.6941 27.5806 37.7463 27.6558 37.782 27.7387C37.8177 27.8216 37.836 27.9105 37.836 28.0003C37.836 28.09 37.8177 28.1789 37.782 28.2618C37.7463 28.3447 37.6941 28.4199 37.6282 28.4831L29.196 36.6441C29.0652 36.7697 28.8885 36.8406 28.7042 36.8413C28.6117 36.8418 28.52 36.8247 28.4344 36.7908C28.3488 36.757 28.2709 36.7071 28.2053 36.6441C28.1394 36.5809 28.0871 36.5056 28.0514 36.4228C28.0158 36.3399 27.9974 36.251 27.9974 36.1612C27.9974 36.0714 28.0158 35.9826 28.0514 35.8997C28.0871 35.8168 28.1394 35.7416 28.2053 35.6784L35.4429 28.6803H18.8666C18.6803 28.6803 18.5015 28.6087 18.3698 28.4812C18.238 28.3536 18.164 28.1806 18.164 28.0003C18.164 27.8199 18.238 27.6469 18.3698 27.5194C18.5015 27.3918 18.6803 27.3202 18.8666 27.3202Z"
                    fill="#282828"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M29.3116 19.2439C29.1492 19.0877 28.9296 19 28.7006 19C28.4718 19 28.2522 19.0876 28.0898 19.2438C28.0086 19.3218 27.9441 19.4145 27.9001 19.5167C27.8561 19.6189 27.8334 19.7286 27.8334 19.8393C27.8334 19.95 27.8561 20.0597 27.9001 20.1619C27.944 20.264 28.0084 20.3567 28.0895 20.4346L35.04 27.1615H18.8666C18.6368 27.1615 18.4164 27.2499 18.2538 27.4072C18.0913 27.5645 18 27.7778 18 28.0003C18 28.2227 18.0913 28.4361 18.2538 28.5934C18.4164 28.7507 18.6368 28.839 18.8666 28.839H35.0468L28.0898 35.5657C28.0087 35.6436 27.9441 35.7365 27.9001 35.8387C27.8561 35.9409 27.8334 36.0505 27.8334 36.1612C27.8334 36.272 27.8561 36.3816 27.9001 36.4838C27.9441 36.586 28.0086 36.6788 28.0898 36.7567C28.1708 36.8345 28.2668 36.896 28.3724 36.9377C28.478 36.9795 28.591 37.0006 28.7051 37C28.9324 36.999 29.1501 36.9116 29.3115 36.7567L37.7436 28.5958C37.8248 28.5179 37.8894 28.4249 37.9333 28.3228C37.9773 28.2206 38 28.111 38 28.0003C38 27.8895 37.9773 27.7799 37.9333 27.6777C37.8894 27.5756 37.825 27.4829 37.7439 27.405L29.3116 19.2439ZM29.0804 19.469L37.5123 27.6296C37.5627 27.6781 37.6033 27.7362 37.6307 27.7997C37.658 27.8633 37.6721 27.9314 37.6721 28.0003C37.6721 28.0691 37.658 28.1372 37.6307 28.2008C37.6033 28.2643 37.5632 28.322 37.5127 28.3705L29.0806 36.5314C28.9803 36.6275 28.8446 36.682 28.7035 36.6826C28.6326 36.683 28.562 36.6699 28.4964 36.6439C28.4308 36.618 28.3711 36.5797 28.3207 36.5314C28.2702 36.4829 28.2301 36.4253 28.2028 36.3617C28.1754 36.2982 28.1614 36.2301 28.1614 36.1612C28.1614 36.0924 28.1754 36.0242 28.2028 35.9607C28.2301 35.8972 28.2702 35.8395 28.3207 35.791L35.839 28.5217H18.8666C18.7238 28.5217 18.5867 28.4667 18.4857 28.3689C18.3847 28.2712 18.3279 28.1385 18.3279 28.0003C18.3279 27.862 18.3847 27.7294 18.4857 27.6316C18.5867 27.5338 18.7238 27.4789 18.8666 27.4789H35.8317L28.3212 20.21C28.2707 20.1615 28.2301 20.1034 28.2028 20.0398C28.1754 19.9763 28.1614 19.9081 28.1614 19.8393C28.1614 19.7705 28.1754 19.7023 28.2028 19.6388C28.2301 19.5753 28.2702 19.5176 28.3207 19.4691C28.4216 19.372 28.5583 19.3174 28.7006 19.3174C28.8429 19.3174 28.9795 19.372 29.0804 19.469Z"
                    fill="#282828"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="coop-u-padding-resp-b-48-24 coop-u-padding-resp-t-48-24 no-print">
          <div class="coop-l-section__inner coop-l-container">
            <h2 class="coop-l-section__heading coop-u-padding-resp-b-24-12">
              Articles
            </h2>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--medium-6">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.coop.co.uk/insurance/hub/benefits-of-nature-in-retirement?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/nature.jpg"
                            srcset="/dist/images/cards/nature.jpg 1x, /dist/images/cards/nature@2x.jpg 2x"
                            width="615"
                            height="204"
                            alt="How to enjoy the benefits of nature in retirement"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              How to enjoy the benefits of nature in retirement
                            </span>
                          </h3>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-6">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.coop.co.uk/insurance/hub/how-to-have-a-happy-retirement?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/happy-retirement.jpg"
                            srcset="/dist/images/cards/happy-retirement.jpg 1x, /dist/images/cards/happy-retirement@2x.jpg 2x"
                            width="615"
                            height="204"
                            alt="How to have a happy retirement"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              How to have a happy retirement
                            </span>
                          </h3>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </div>
        <div v-show="false" class="coop-c-hero coop-c-hero--squircle coop-u-blue-mid-4-bg coop-u-white coop-u-margin-0 no-print">
          <div class="coop-c-hero__inner coop-u-clearfix coop-u-padding-resp-t-48-24 coop-u-padding-resp-b-48-24">
            <h2 class="coop-u-margin-resp-b-48-24">
              Show your community you care
            </h2>
            <article
              class="coop-c-editorialcard coop-c-editorialcard--horizontal"
              style="z-index: 1;"
            >
              <a
                href="https://co-operate.coop.co.uk/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                class="coop-c-editorialcard__link"
                data-contenttype="Card|Editorial"
                data-contentparent=""
                data-linktext=""
                target="_blank"
              >
                <div class="coop-c-editorialcard__inner">
                  <figure class="coop-c-editorialcard__media">
                    <picture class="coop-c-editorialcard__image">
                      <img
                        src="/dist/images/cards/get-involved.jpg"
                        srcset="/dist/images/cards/get-involved.jpg 1x, /dist/images/cards/get-involved@2x.jpg 2x"
                        width="618"
                        height="346"
                        alt="Get involved"
                      >
                    </picture>
                  </figure>
                  <div class="coop-c-editorialcard__content">
                    <header class="coop-c-editorialcard__header">
                      <h3 class="coop-c-editorialcard__title">
                        <span>
                          Get involved
                        </span>
                      </h3>
                    </header>
                    <div class="coop-c-editorialcard__body">
                      <p>We can connect you with groups that need help. Use your time, skills and enthusiasm to make a direct impact in your community and beyond. Thousands of opportunities. Find the perfect one for you.</p>
                    </div>
                  </div>
                </div>
              </a>
            </article>
          </div>
          <div
            class="coop-c-hero__decoration coop-c-hero__decoration--right coop-c-hero__decoration--community"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 246 302"
            ><path
              d="M16.4112 -44.1113C43.1324 -85.0645 109.935 -101.039 161.345 -85.9358C213.044 -70.8325 249.641 -24.9418 293.499 16.0114C337.647 57.255 389.056 93.8515 400.093 141.485C411.42 189.118 382.085 247.789 337.937 276.834C293.789 305.878 235.119 305.007 185.742 295.422C136.657 286.128 96.5749 268.12 69.8536 239.075C42.842 210.321 28.9005 170.239 15.5398 117.087C2.17924 63.9353 -10.6005 -2.86768 16.4112 -44.1113Z"
              fill="#80B7FF"
            /></svg>
          </div>
        </div>
        <div class="coop-u-padding-resp-b-24-12 coop-u-padding-resp-t-48-24 no-print coop-u-blue-light-10-bg">
          <div class="coop-l-section__inner coop-l-container">
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--medium-6">
                <article class="coop-c-editorialcard">
                  <div class="food-c-hero__text">
                    <h2>We do things differently</h2>
                    <p>Since 2016, our members have helped direct over £115 million to more than 39,000 grassroots projects — supporting everything from food pantries to mental wellbeing support.</p>
                    <p>As a member, you can choose a cause close to home through the <span class="coop-u-nowrap">Co-op</span> App and be part of the difference we’re making, together.</p>
                    <div class="coop-c-hero__link-container">
                        <a class="coop-btn coop-btn--blue " href="https://membership.coop.co.uk/causes?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning" target="_self" title="Choose a local cause" data-contenttype="Hero" data-contentparent="We do things differently" data-linktext="Choose a local cause">
                          <span class="coop-t-link__anchor">Choose a local cause</span>
                        </a>
                    </div>
                  </div>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-6">
                <article class="coop-c-editorialcard">
                  <img
                    class="coop-c-hero__image"
                    src="/dist/images/cards/things-differently.jpg"
                    srcset="/dist/images/cards/things-differently.jpg 1x, /dist/images/cards/things-differently@2x.jpg 2x"
                    width="100%"
                    alt="We do things differently"
                  >
                </article>
              </div>
            </div>
          </div>
        </div>
        <div
          class="coop-u-padding-resp-b-64-32 coop-u-padding-resp-t-64-32 no-print"
        >
          <div
            id="health"
            class="coop-l-section__inner coop-l-container"
          >
            <h2 class="coop-l-section__heading">
              Health and wellbeing
            </h2>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--large-8">
                <p
                  class="coop-u-padding-resp-b-24-12"
                >
                  We want to make your healthier choices easy, because we all know that a balanced diet, together with an active lifestyle, is the key to good health and wellbeing.
                </p>
              </div>
            </div>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--medium-6">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.coop.co.uk/health-wellbeing/healthy-lifestyles?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/healthy-diet-u.jpg"
                            srcset="/dist/images/cards/healthy-diet-u.jpg 1x, /dist/images/cards/healthy-diet-u@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Eating a healthy, balanced diet"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Eating a healthy, balanced diet
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>
                              Whether it's simple portion size changes or clever ways to cut down on sugar and salt, find out ways to make healthier choices.
                            </p>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-4" v-show="false">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.coop.co.uk/health-wellbeing/parkrun?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/parkrun.jpg"
                            srcset="/dist/images/cards/parkrun.jpg 1x, /dist/images/cards/parkrun@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Get active with Parkrun"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Get active with Parkrun
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>
                              Find out how our partnership with parkrun UK helps you stay active and enjoy recipes that make you feel good after exercise.
                            </p>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-6">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.coop.co.uk/health-wellbeing/five-a-day?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/5-a-day-u.jpg"
                            srcset="/dist/images/cards/5-a-day-u.jpg 1x, /dist/images/cards/5-a-day-u@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Getting your 5 a day"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Getting your 5 a day
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>
                              What are the benefits of fruit and veg? Find all the answers and inspiration to get your 5 a day here.
                            </p>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
            </div>
            <div class="coop-u-padding-resp-t-8-4">
              <a
                href="https://www.coop.co.uk/health-wellbeing?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                target="_blank"
                class="coop-c-more-button"
              >
                <span class="coop-u-black">
                  See all
                </span>
                <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.7071 8.7073C22.0976 8.31677 22.0976 7.68361 21.7071 7.29308L15.3431 0.929123C14.9526 0.538599 14.3195 0.538599 13.9289 0.929123C13.5384 1.31965 13.5384 1.95281 13.9289 2.34334L19.5858 8.00019L13.9289 13.6571C13.5384 14.0476 13.5384 14.6807 13.9289 15.0713C14.3195 15.4618 14.9526 15.4618 15.3431 15.0713L21.7071 8.7073ZM0 9.00019H21V7.00019H0V9.00019Z" fill="#282828"/>
                </svg>
              </a>

            </div>
          </div>
        </div>
        <div class="coop-u-padding-resp-b-48-24 coop-u-padding-resp-t-48-24 coop-u-blue-light-10-bg no-print">
          <div class="coop-l-section__inner coop-l-container">
            <h2 class="coop-l-section__heading coop-u-padding-resp-b-24-12">
              Help tackle food waste
            </h2>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--medium-4">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.yourlocalpantry.co.uk/join-a-pantry/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Join a pantry
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>With pantries located across the UK, you can find out if you have a pantry in your community and become a member.</p>
                          </div>
                          <div v-show="false" class="coop-c-signpost__content coop-u-padding-0 coop-u-padding-resp-t-24-12">
                            <h3 class="coop-c-signpost__title coop-u-black">
                              Find activities in your local area
                            </h3>
                            <span
                              class="coop-c-signpost__icon"
                              aria-hidden="true"
                            >
                              <svg
                                class="coop-c-signpost__icon__svg"
                                viewBox="0 0 16 29"
                              >
                                <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                              </svg>
                            </span>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-4">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.yourlocalpantry.co.uk/start-a-pantry/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Start a pantry
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>Would your neighbourhood benefit from a pantry? Find out all you need to know about setting up a pantry in your area.</p>
                          </div>
                          <div v-show="false" class="coop-c-signpost__content coop-u-padding-0 coop-u-padding-resp-t-24-12">
                            <h3 class="coop-c-signpost__title coop-u-black">
                              Find ways to improve your mental wellbeing
                            </h3>
                            <span
                              class="coop-c-signpost__icon"
                              aria-hidden="true"
                            >
                              <svg
                                class="coop-c-signpost__icon__svg"
                                viewBox="0 0 16 29"
                              >
                                <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                              </svg>
                            </span>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-4">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.yourlocalpantry.co.uk/help-a-pantry/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Help a pantry
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>From volunteering to donating food, there are many ways you can help support a pantry and give back to your community.</p>
                          </div>
                          <div v-show="false" class="coop-c-signpost__content coop-u-padding-0 coop-u-padding-resp-t-24-12">
                            <h3 class="coop-c-signpost__title coop-u-black">
                              Find ways to improve your mental wellbeing
                            </h3>
                            <span
                              class="coop-c-signpost__icon"
                              aria-hidden="true"
                            >
                              <svg
                                class="coop-c-signpost__icon__svg"
                                viewBox="0 0 16 29"
                              >
                                <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                              </svg>
                            </span>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </div>
        <div
          class="coop-u-padding-resp-b-48-24 coop-u-padding-resp-t-48-24 no-print"
          :class="{'pull-up': surveyStore.surveyResult.feel === '4' || surveyStore.surveyResult.feel === '5'}"
        >
          <div
            id="charities"
            class="coop-l-section__inner coop-l-container"
          >
            <h2 class="coop-l-section__heading">
              Other support
            </h2>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--large-8">
                <p
                  v-if="surveyStore.surveyResult.feel === '4' || surveyStore.surveyResult.feel === '5'"
                  class="coop-u-padding-resp-b-24-12"
                >
                  As you've told us that you feel anxious or sad these are some places where you can access help.
                </p>
                <p
                  v-else
                  class="coop-u-padding-resp-b-24-12"
                >
                  If you are struggling or need financial help, we recommend you speak to someone who may be able to help you.
                </p>
              </div>
            </div>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--medium-4">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.mind.org.uk/"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/mind.jpg"
                            srcset="/dist/images/cards/mind.jpg 1x, /dist/images/cards/mind@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Mind"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Mind
                            </span>
                          </h3>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-4">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.moneyhelper.org.uk/en/pensions-and-retirement"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/money-helper.jpg"
                            srcset="/dist/images/cards/money-helper.jpg 1x, /dist/images/cards/money-helper@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Money Helper"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Money Helper
                            </span>
                          </h3>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-4">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://mentalhealth-uk.org/"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/mhuk.jpg"
                            srcset="/dist/images/cards/mhuk.jpg 1x, /dist/images/cards/mhuk@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Mental Health UK"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Mental Health UK
                            </span>
                          </h3>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </div>
        <div
          class="coop-u-padding-resp-b-64-32 coop-u-padding-resp-t-64-32 coop-u-blue-light-10-bg no-print"
        >
          <div
            id="community"
            class="coop-l-section__inner coop-l-container"
          >
            <h2 class="coop-l-section__heading coop-u-padding-resp-b-24-12">
              Co-op and your community
            </h2>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--large-8">
                <!--p
                  class="coop-u-padding-resp-b-24-12"
                >
                  Member Pioneers and Member Pioneer Co-ordinators work together with Co-op colleagues and local causes to make a difference in their communities.
                </p-->
              </div>
            </div>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--medium-6">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://joinin.coop.co.uk/opportunities/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/join-and-say.jpg"
                            srcset="/dist/images/cards/join-and-say.jpg 1x, /dist/images/cards/join-and-say@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Join in and have your say"
                            style="aspect-ratio: 1230 / 408; object-fit: cover"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Join in and have your say
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>
                              As a member, you can help shape our new products, services and ethics by getting involved with our Join In opportunities.
                            </p>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--medium-6">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://www.coop.co.uk/local-causes?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/local-causes.jpg"
                            srcset="/dist/images/cards/local-causes.jpg 1x, /dist/images/cards/local-causes@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Funding local causes"
                            style="aspect-ratio: 1230 / 408; object-fit: cover"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Funding local causes
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>
                              Discover how our Local Community Fund supports thousands of projects making a difference around the UK.
                            </p>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
              <div v-show="false" class="coop-l-grid__item coop-l-grid__item--medium-4">
                <article class="coop-c-editorialcard">
                  <a
                    href="https://co-operate.coop.co.uk/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-editorialcard__link"
                    data-contenttype="Card|Editorial"
                    data-contentparent=""
                    data-linktext=""
                    target="_blank"
                  >
                    <div class="coop-c-editorialcard__inner">
                      <figure class="coop-c-editorialcard__media">
                        <picture class="coop-c-editorialcard__image">
                          <img
                            src="/dist/images/cards/co-operate.jpg"
                            srcset="/dist/images/cards/co-operate.jpg 1x, /dist/images/cards/co-operate@2x.jpg 2x"
                            width="399"
                            height="204"
                            alt="Co-operate"
                          >
                        </picture>
                      </figure>
                      <div class="coop-c-editorialcard__content">
                        <header class="coop-c-editorialcard__header">
                          <h3 class="coop-c-editorialcard__title">
                            <span>
                              Co-operate
                            </span>
                          </h3>
                          <div class="coop-c-editorialcard__body">
                            <p>
                              Discover our online community centre that helps people find an activity, join a group or set up their own.
                            </p>
                          </div>
                        </header>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
            </div>
            <div v-show="false" class="coop-u-padding-resp-t-8-4 coop-u-padding-resp-b-32-16">
              <div class="coop-u-shadow coop-u-white-bg">
                <img
                  src="/dist/images/raised-by-members.png"
                  srcset="/dist/images/raised-by-members.png 1x, /dist/images/raised-by-members@2x 2x"
                  style="display: block; margin: 0 auto;"
                  alt="Raised by members"
                >
              </div>
            </div>
            <div class="coop-u-padding-resp-t-8-4">
              <a
                href="https://www.coop.co.uk/communities?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                target="_blank"
                class="coop-c-more-button"
              >
                <span class="coop-u-black">
                  See all
                </span>
                <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.7071 8.7073C22.0976 8.31677 22.0976 7.68361 21.7071 7.29308L15.3431 0.929123C14.9526 0.538599 14.3195 0.538599 13.9289 0.929123C13.5384 1.31965 13.5384 1.95281 13.9289 2.34334L19.5858 8.00019L13.9289 13.6571C13.5384 14.0476 13.5384 14.6807 13.9289 15.0713C14.3195 15.4618 14.9526 15.4618 15.3431 15.0713L21.7071 8.7073ZM0 9.00019H21V7.00019H0V9.00019Z" fill="#282828"/>
                </svg>
              </a>

            </div>
          </div>
        </div>
        <div
          class="coop-u-padding-resp-b-64-32 coop-u-padding-resp-t-64-32 no-print coop-c-coop-member"
        >
          <div
            id="coop-member"
            class="coop-l-section__inner coop-l-container"
          >
            <div class="coop-l-grid">
              <div class="coop-l-grid__item--large-offset-6 coop-l-grid__item--large-6 coop-l-grid__item--medium-offset-3 coop-l-grid__item--medium-9">
                <h2 class="coop-l-section__heading">
                  Become a Co-op member
                </h2>
                <p class="coop-u-padding-resp-t-2-0 coop-u-margin-resp-b-16-8">
                  Co-op Members help us support local communities. We share our profits with local communities through our community fund and our charity.
                </p>
                <p class="coop-u-margin-t-0 coop-u-margin-b-8">
                  Join for £1 today to get Member Prices, personalised offers, and first-in-line access to tickets at Co-op Live.
                </p>
                <div class="">
                  <a
                    href="https://www.coop.co.uk/membership?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-btn coop-btn--primary coop-u-margin-resp-t-8-4"
                    target="_blank"
                  >
                    <span>
                      Become a member
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section class="coop-l-section coop-u-blue-dark-3-bg coop-u-white coop-u-padding-resp-b-48-24 coop-u-padding-resp-t-48-24 no-print">
          <div class="coop-l-section__inner coop-l-container">
            <div class="coop-l-grid">
              <div class="coop-l-grid__item">
                <h2 class="coop-l-section__heading coop-u-padding-resp-b-24-12">
                  Ways we can help
                </h2>
              </div>
            </div>
            <div class="coop-l-grid">
              <div class="coop-l-grid__item coop-l-grid__item--small-6 coop-l-grid__item--large-4 coop-u-flex">
                <div class="coop-c-signpost-list__item coop-c-signpost">
                  <a
                    href="https://www.co-oplegalservices.co.uk/making-a-will/lasting-powers-of-attorney/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-signpost__link"
                    data-contenttype="Signpost"
                    data-contentparent="Ways we can help"
                    data-linktext="LPAs"
                    target="_blank"
                  >
                    <div class="coop-c-signpost__content">
                      <h3 class="coop-c-signpost__title">
                        LPAs
                      </h3>
                      <span
                        class="coop-c-signpost__icon"
                        aria-hidden="true"
                      >
                        <svg
                          class="coop-c-signpost__icon__svg"
                          viewBox="0 0 16 29"
                        >
                          <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                        </svg>
                      </span>
                    </div>
                  </a>
                </div>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--small-6 coop-l-grid__item--large-4 coop-u-flex">
                <div class="coop-c-signpost-list__item coop-c-signpost">
                  <a
                    href="https://www.co-oplegalservices.co.uk/making-a-will/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-signpost__link"
                    data-contenttype="Signpost"
                    data-contentparent="Ways we can help"
                    data-linktext="Wills"
                    target="_blank"
                  >
                    <div class="coop-c-signpost__content">
                      <h3 class="coop-c-signpost__title">
                        Wills
                      </h3>
                      <span
                        class="coop-c-signpost__icon"
                        aria-hidden="true"
                      >
                        <svg
                          class="coop-c-signpost__icon__svg"
                          viewBox="0 0 16 29"
                        >
                          <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                        </svg>
                      </span>
                    </div>
                  </a>
                </div>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--small-6 coop-l-grid__item--large-4 coop-u-flex">
                <div class="coop-c-signpost-list__item coop-c-signpost">
                  <a
                    href="https://www.coop.co.uk/funeralcare/funeral-plans?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-signpost__link"
                    data-contenttype="Signpost"
                    data-contentparent="Ways we can help"
                    data-linktext="Funeral plans"
                    target="_blank"
                  >
                    <div class="coop-c-signpost__content">
                      <h3 class="coop-c-signpost__title">
                        Funeral plans
                      </h3>
                      <span
                        class="coop-c-signpost__icon"
                        aria-hidden="true"
                      >
                        <svg
                          class="coop-c-signpost__icon__svg"
                          viewBox="0 0 16 29"
                        >
                          <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                        </svg>
                      </span>
                    </div>
                  </a>
                </div>
              </div>
              <!--div class="coop-l-grid__item coop-l-grid__item--small-6 coop-l-grid__item--large-4 coop-u-flex">
                <div class="coop-c-signpost-list__item coop-c-signpost">
                  <a
                    href="https://www.coop.co.uk/insurance/lifetime-mortgages?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-signpost__link"
                    data-contenttype="Signpost"
                    data-contentparent="Ways we can help"
                    data-linktext="Lifetime mortgage"
                    target="_blank"
                  >
                    <div class="coop-c-signpost__content">
                      <h3 class="coop-c-signpost__title">
                        Lifetime mortgage
                      </h3>
                      <span
                        class="coop-c-signpost__icon"
                        aria-hidden="true"
                      >
                        <svg
                          class="coop-c-signpost__icon__svg"
                          viewBox="0 0 16 29"
                        >
                          <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                        </svg>
                      </span>
                    </div>
                  </a>
                </div>
              </div -->
              <div class="coop-l-grid__item coop-l-grid__item--small-6 coop-l-grid__item--large-4 coop-u-flex">
                <div class="coop-c-signpost-list__item coop-c-signpost">
                  <a
                    href="https://www.coop.co.uk/insurance/life-cover?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-signpost__link"
                    data-contenttype="Signpost"
                    data-contentparent="Ways we can help"
                    data-linktext="Life insurance"
                    target="_blank"
                  >
                    <div class="coop-c-signpost__content">
                      <h3 class="coop-c-signpost__title">
                        Life insurance
                      </h3>
                      <span
                        class="coop-c-signpost__icon"
                        aria-hidden="true"
                      >
                        <svg
                          class="coop-c-signpost__icon__svg"
                          viewBox="0 0 16 29"
                        >
                          <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                        </svg>
                      </span>
                    </div>
                  </a>
                </div>
              </div>
              <div class="coop-l-grid__item coop-l-grid__item--small-6 coop-l-grid__item--large-4 coop-u-flex">
                <div class="coop-c-signpost-list__item coop-c-signpost">
                  <a
                    href="https://www.coop.co.uk/insurance/travel-insurance?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-signpost__link"
                    data-contenttype="Signpost"
                    data-contentparent="Ways we can help"
                    data-linktext="Travel insurance"
                    target="_blank"
                  >
                    <div class="coop-c-signpost__content">
                      <h3 class="coop-c-signpost__title">
                        Travel insurance
                      </h3>
                      <span
                        class="coop-c-signpost__icon"
                        aria-hidden="true"
                      >
                        <svg
                          class="coop-c-signpost__icon__svg"
                          viewBox="0 0 16 29"
                        >
                          <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                        </svg>
                      </span>
                    </div>
                  </a>
                </div>
              </div>
              <!--div class="coop-l-grid__item coop-l-grid__item--small-6 coop-l-grid__item--large-4 coop-u-flex">
                <div class="coop-c-signpost-list__item coop-c-signpost">
                  <a
                    href="https://www.coop.co.uk/insurance/loans?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-signpost__link"
                    data-contenttype="Signpost"
                    data-contentparent="Ways we can help"
                    data-linktext="Loan"
                    target="_blank"
                  >
                    <div class="coop-c-signpost__content">
                      <h3 class="coop-c-signpost__title">
                        Loan
                      </h3>
                      <span
                        class="coop-c-signpost__icon"
                        aria-hidden="true"
                      >
                        <svg
                          class="coop-c-signpost__icon__svg"
                          viewBox="0 0 16 29"
                        >
                          <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                        </svg>
                      </span>
                    </div>
                  </a>
                </div>
              </div -->
              <div class="coop-l-grid__item coop-l-grid__item--small-6 coop-l-grid__item--large-4 coop-u-flex">
                <div class="coop-c-signpost-list__item coop-c-signpost">
                  <a
                    href="https://www.co-oplegalservices.co.uk/probate-solicitors/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                    class="coop-c-signpost__link"
                    data-contenttype="Signpost"
                    data-contentparent="Ways we can help"
                    data-linktext="Probate"
                    target="_blank"
                  >
                    <div class="coop-c-signpost__content">
                      <h3 class="coop-c-signpost__title">
                        Probate
                      </h3>
                      <span
                        class="coop-c-signpost__icon"
                        aria-hidden="true"
                      >
                        <svg
                          class="coop-c-signpost__icon__svg"
                          viewBox="0 0 16 29"
                        >
                          <path d="M1.909 28.11a1.575 1.575 0 0 1-1.115-2.691L11.713 14.5.793 3.58a1.575 1.575 0 1 1 2.23-2.228l12.033 12.033a1.575 1.575 0 0 1 0 2.229L3.023 27.647c-.307.308-.71.463-1.114.463z" />
                        </svg>
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="coop-l-section coop-u-padding-resp-t-24-12">
          <div class="coop-l-section__inner coop-l-container">
            <p>
              *A survey of 1305 UK adults commissioned by The Co-op conducted in April 2022 found that only 39% had a Will in place.
            </p>
          </div>
        </section>
      </div>
    </main>
    <footer class="ssn-footer ssn">
      <div class="ssn-footer-inner ssn-wrap">
        <div class="ssn-footer-legal no-print">
          <ul>
            <li>
              <a
                href="https://www.coop.co.uk/insurance/about-us/privacy-and-cookies?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                data-linktext="Privacy and cookies"
                data-contenttype="Footer"
                data-contentparent="Legal"
                target="_blank"
              >Privacy and cookies</a>
            </li><li>
              <a
                href="https://www.coop.co.uk/accessibility?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning"
                data-linktext="Accessibility"
                data-contenttype="Footer"
                data-contentparent="Legal"
                target="_blank"
              >Accessibility</a>
            </li>
          </ul>
        </div><div class="ssn-footer-smallprint">
          <p>
            Co-op Insurance Services is a trading name of Co-op Insurance Services Limited, part of the Co-op Group. Registered in England and Wales, with <a
              data-contentparent="Legal"
              data-contenttype="Footer"
              data-linktext="society registration number RS004390"
              href="https://find-and-update.company-information.service.gov.uk/company/RS004390"
              target="_blank"
            >society registration number RS004390</a>. Registered office: 1 Angel Square, Manchester, Lancashire, M60 0AG. Authorised and regulated by the <a
              data-contentparent="Legal"
              data-contenttype="Footer"
              data-linktext="Financial Conduct Authority under register number 779364"
              href="https://register.fca.org.uk/s/firm?id=001b000003oTvbWAAS"
              target="_blank"
            >Financial Conduct Authority under register number 779364</a>.
          </p>
          <p>
            The Co-operative Legal Services and Co-op Legal Services are trading names for Co-operative Legal Services Limited,
            a limited company registered in England and Wales under company number 05671209.<br>
            Registered office address: 1 Angel Square, Manchester, M60 0AG.<br>
            Co-op Legal Services is authorised and regulated by the <a href="https://www.sra.org.uk/consumers/register/organisation/?sraNumber=567391" target="_blank">Solicitors Regulation Authority under registration number 567391</a>.
          </p>
          <p>Co-op Funeralcare is a trading name for Funeral Services Limited (FSL) and Co-op Funeral Plans Limited (CFPL),
            both of which are part of the Co-operative Group Limited. FSL provides our Co-op funeral services and is a
            registered society, with its registered office at 1 Angel Square, Manchester, M60 0AG (registration number 30808R).
            CFPL provides our Co-op funeral plans and is a registered society, with its registered office at 1 Angel Square,
            Manchester, M60 0AG (registration number 4818).</p>
          <p>Co-op Insurance, Co-op Legal Services, and Co-op Funeralcare are part of the Co-operative Group. Co-operative Group is a society registered in England (no 525R). Registered office is 1 Angel Square, Manchester, M60 0AG.</p>
          <p>Co-op Life Cover and Co-op Over 50 Life Insurance are introduced by Co-op Insurance and provided, underwritten and administered by Legal & General Assurance Society Limited, who are not part of the Co-operative Group.</p>
          <!-- p>Lifetime mortgages are introduced by Co-op Insurance and provided, underwritten, and administered by Legal & General, who are not part of the Co-operative Group.</p -->
          <p>Wills and Lasting Powers of Attorney are not regulated by the Financial Conduct Authority.</p>
          <p>© Co-operative Group Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
// eslint-disable-next-line import/no-unresolved
import { register } from 'swiper/element-bundle';
// eslint-disable-next-line import/no-unresolved
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useSurveyStore } from '@/stores/survey.js';
import ProfanityList from '../../profanityList';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

register();

const surveyStore = useSurveyStore();
const profanityList = new ProfanityList();
const swiperInvolved = ref(null);
const mobileNavOpen = ref(null);

const status = computed(() => {
  // if already in retirement
  if (surveyStore.surveyResult.yearsToRetirement === '6') {
    switch (surveyStore.surveyResult.feel) {
      case '1':
      case '2':
        return 'happy';
      case '3':
        return 'neutral';
      case '4':
      case '5':
        return 'anxious';
      default:
        return null;
    }
  }

  // if not yet in retirement
  let score = 0;
  switch (surveyStore.surveyResult.feel) {
    case '1':
    case '2':
      score += 0;
      break;
    case '3':
      score += 1;
      break;
    case '4':
      score += 3;
      break;
    case '5':
      score += 4;
      break;
    default:
      break;
  }
  switch (surveyStore.surveyResult.prepared) {
    case '1':
      score += 0;
      break;
    case '2':
      score += 1;
      break;
    case '3':
      score += 5;
      break;
    default:
      break;
  }

  if (score === 0) {
    return 'happy';
  }
  if (score <= 3) {
    return 'neutral';
  }
  if (score <= 5) {
    return 'anxious';
  }
  return 'unprepared';
});

const introCopy = computed(() => {
  if (status.value === 'happy') {
    return 'You\'ve said you\'re feeling great already, but see if there\'s anything else you can do to continue to enhance your positive outlook.';
  }
  if (status.value === 'anxious') {
    return 'If you are feeling concerned about the future there are <a href="#charities">charities and advice lines</a> you can talk to. Alongside this, the checklist below may help break things down for you in a more manageable way.';
  }
  if (status.value === 'unprepared') {
    return 'You told us you\'re not feeling prepared for retirement. Starting to think about it is a great first step, and you might find some of the <a href="#charities">guides and information</a> below helpful.';
  }
  return 'A lot of people have reservations about retirement and the future. Use the checklist and guides below to help organise and plan ahead.';
});

const filteredName = computed(() => {
  const { name } = surveyStore.surveyResult;
  const badWords = profanityList.getProfanityList();
  const nameArray = name.replace(/[^a-zA-Z0-9 ]/g, ' ').split(' ');
  const badWord = nameArray.find((word) => badWords.includes(word.toLowerCase()));
  if (badWord) {
    return name.replace(badWord, '###');
  }
  return name;
});

const mainTitle = computed(() => {
  if (status.value === 'happy') {
    return 'keep your positive momentum going';
  }

  return 'here\'s your retirement checklist';
});

const willsCallout = computed(() => {
  if (!surveyStore.surveyResult.products.includes('3')) {
    return `
      <p>You're not alone, over half of UK adults we asked don't have a will*. It is important to have a will and making one can be straightforward when you have a specialist to help you complete each step. </p>
      <p><a href="https://les.coop.co.uk/wills?organisation=retirement-checklist&utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning" target="_blank">Making a will</a> clarifies your wishes and enables you to give your loved ones financial protection after you die.</p>
    `;
  }
  return `
    <p>It's great that you've told us you have a will in place, as less than half of the UK population we asked do*. Make sure you keep it up to date if your circumstances change.</p>
    <p>Did you know that different types of will can protect your assets in different ways. <a href="https://www.co-oplegalservices.co.uk/making-a-will/?utm_source=retirement+checklist&utm_medium=referral&utm_campaign=life+planning" target="_blank" class="no-print">Check which will is right for you</a>.</p>
  `;
});

const printPage = () => {
  window.print();
};

const convertLinkToText = (string) => {
  // convert all `<a href="..." ...>...</a>` to `link text (link)`
  const regex = /<a href="([^"]*)"([^>]*)>([^<]*)<\/a>/g;
  // if link text ($3) is 'here' output 'link_text: link', else output 'link_text (link)'
  return string.replace(regex, (matched) => {
    return matched.includes('here') ? `${matched.replace(regex, '$3: $1')}` : `${matched.replace(regex, '$3 ($1)')}`;
  });
};

const downloadPDF = () => {
  const logoSVG = '<svg viewBox="256.9522 128.4218 23.7033 25.0242" width="23.7033" height="25.0242" xmlns="http://www.w3.org/2000/svg"> <path fill="#00B1E7" d="M 280.53 133.934 C 280.53 133.059 280.405 132.183 280.155 131.307 C 279.843 130.244 279.029 129.431 278.028 128.993 C 275.968 128.242 273.709 128.242 271.649 128.993 C 270.587 129.369 269.836 130.244 269.522 131.307 C 269.023 133.059 269.023 134.872 269.522 136.623 C 269.836 137.686 270.649 138.5 271.649 138.938 C 272.65 139.312 273.775 139.501 274.84 139.437 C 275.902 139.437 277.027 139.25 278.028 138.938 C 279.091 138.562 279.843 137.686 280.155 136.623 C 280.405 135.685 280.53 134.81 280.53 133.934 Z M 277.091 133.934 C 277.091 134.372 277.027 134.81 276.903 135.184 C 276.715 135.747 276.277 136.185 275.652 136.311 C 275.089 136.436 274.526 136.436 274.026 136.311 C 273.463 136.185 272.963 135.809 272.776 135.184 C 272.525 134.372 272.525 133.433 272.776 132.621 C 272.963 132.058 273.401 131.62 274.026 131.495 C 274.589 131.369 275.152 131.369 275.652 131.495 C 276.215 131.62 276.715 131.996 276.903 132.621 C 277.027 133.059 277.091 133.496 277.091 133.934 M 267.96 148.318 C 268.459 146.568 268.459 144.753 267.96 143.002 C 267.647 141.939 266.833 141.127 265.832 140.689 C 263.773 139.938 261.514 139.938 259.454 140.689 C 258.391 141.063 257.64 141.939 257.328 143.002 C 256.827 144.753 256.827 146.568 257.328 148.318 C 257.64 149.382 258.453 150.194 259.454 150.632 C 261.518 151.383 263.769 151.383 265.832 150.632 C 266.833 150.258 267.647 149.382 267.96 148.318 M 264.895 145.692 C 264.895 146.13 264.833 146.568 264.708 146.942 C 264.519 147.505 264.081 147.943 263.456 148.069 C 262.893 148.194 262.331 148.194 261.83 148.069 C 261.267 147.943 260.767 147.567 260.58 146.942 C 260.329 146.067 260.329 145.191 260.58 144.379 C 260.767 143.816 261.205 143.378 261.83 143.253 C 262.393 143.127 262.956 143.127 263.456 143.253 C 264.019 143.378 264.519 143.752 264.708 144.379 C 264.833 144.817 264.895 145.254 264.895 145.692 M 264.895 133.871 L 268.334 133.871 C 268.334 132.995 268.209 132.12 267.96 131.244 C 267.647 130.181 266.833 129.369 265.832 128.931 C 263.769 128.242 261.518 128.242 259.454 128.993 C 258.391 129.369 257.64 130.244 257.328 131.307 C 256.827 133.059 256.827 134.872 257.328 136.623 C 257.64 137.686 258.453 138.5 259.454 138.938 C 260.455 139.312 261.58 139.437 262.644 139.437 C 263.707 139.437 264.833 139.25 265.832 138.938 C 266.897 138.562 267.647 137.686 267.96 136.623 C 268.022 136.498 268.022 136.311 268.085 136.185 L 264.833 134.685 C 264.77 134.872 264.77 135.059 264.708 135.248 C 264.519 135.809 264.081 136.247 263.456 136.373 C 262.893 136.498 262.331 136.498 261.83 136.373 C 261.267 136.247 260.767 135.873 260.58 135.248 C 260.329 134.372 260.329 133.433 260.58 132.621 C 260.767 132.058 261.205 131.62 261.83 131.495 C 262.393 131.369 262.956 131.369 263.456 131.495 C 264.019 131.62 264.519 131.996 264.708 132.621 C 264.833 133.059 264.895 133.433 264.895 133.871 M 269.522 143.002 C 269.273 143.878 269.148 144.753 269.148 145.629 L 269.148 153.446 L 272.587 153.446 L 272.587 145.692 C 272.587 145.254 272.65 144.817 272.776 144.441 C 272.963 143.878 273.401 143.44 274.026 143.314 C 274.589 143.191 275.152 143.191 275.652 143.314 C 276.215 143.44 276.715 143.816 276.903 144.441 C 277.153 145.316 277.153 146.192 276.903 147.006 C 276.715 147.567 276.277 148.005 275.714 148.131 C 275.152 148.256 274.589 148.256 274.088 148.131 C 273.964 148.069 273.839 148.069 273.775 148.005 L 274.964 151.195 C 276.028 151.195 277.153 151.008 278.154 150.696 C 279.216 150.32 279.967 149.444 280.279 148.381 C 280.781 146.63 280.781 144.817 280.279 143.065 C 279.967 142.002 279.155 141.189 278.154 140.751 C 276.094 140 273.835 140 271.775 140.751 C 270.587 141.127 269.836 142.002 269.522 143.002" style=""/> </svg>';
  const checkedSVG = '<svg viewBox="363.1006 155.2173 19 19" width="19" height="19" xmlns="http://www.w3.org/2000/svg"> <g style="pointer-events: none;" transform="matrix(0.5757579803466797, 0, 0, 0.5757579803466797, 154.0429229736328, 65.84984588623047)"> <path d="M 365.6 155.217 H 393.6 A 2.5 2.5 0 0 1 396.1 157.717 V 185.717 A 2.5 2.5 0 0 1 393.6 188.217 H 365.6 A 2.5 2.5 0 0 1 363.1 185.717 V 157.717 A 2.5 2.5 0 0 1 365.6 155.217 Z" stroke="#6E6E6E" stroke-width="3" style="fill: rgb(255, 255, 255);"/> <path d="M 390.881 162.017 L 374.011 179.287 L 368.321 173.437 C 368.137 173.246 367.884 173.137 367.619 173.132 C 367.354 173.127 367.097 173.228 366.906 173.412 C 366.715 173.597 366.605 173.849 366.601 174.115 C 366.596 174.38 366.697 174.636 366.881 174.827 L 373.301 181.417 C 373.394 181.512 373.504 181.587 373.626 181.639 C 373.748 181.69 373.879 181.717 374.011 181.717 C 374.145 181.718 374.278 181.692 374.402 181.64 C 374.525 181.589 374.637 181.513 374.731 181.417 L 392.321 163.417 C 392.413 163.323 392.485 163.211 392.534 163.089 C 392.583 162.966 392.607 162.835 392.605 162.703 C 392.603 162.571 392.576 162.441 392.523 162.32 C 392.471 162.199 392.396 162.089 392.301 161.997 C 392.207 161.905 392.095 161.833 391.972 161.784 C 391.85 161.736 391.719 161.711 391.587 161.713 C 391.455 161.715 391.325 161.743 391.204 161.795 C 391.083 161.847 390.973 161.923 390.881 162.017 Z" fill="#595959" style=""/> </g> </svg>';
  const uncheckedSVG = '<svg viewBox="363.1006 155.2173 19 19" width="19" height="19" xmlns="http://www.w3.org/2000/svg"> <g style="pointer-events: none;" transform="matrix(0.5757579803466797, 0, 0, 0.5757579803466797, 154.0429229736328, 65.84984588623047)"> <path d="M 365.6 155.217 H 393.6 A 2.5 2.5 0 0 1 396.1 157.717 V 185.717 A 2.5 2.5 0 0 1 393.6 188.217 H 365.6 A 2.5 2.5 0 0 1 363.1 185.717 V 157.717 A 2.5 2.5 0 0 1 365.6 155.217 Z" stroke="#6E6E6E" stroke-width="3" style="fill: rgb(255, 255, 255);"/> </g> </svg>';
  // logo and title on top
  const docDefinition = {
    pageSize: 'A4',
    info: {
      title: 'Your retirement checklist',
      author: 'Co-op',
    },
    content: [
      {
        table: {
          widths: [26, '*'],
          headerRows: 1,
          body: [
            [
              {
                svg: logoSVG,
                margin: [0, 0, 0, 0],
              },
              {
                text: 'Your retirement checklist',
                margin: [0, 0, 0, 0],
                fontSize: 20,
                bold: true,
              },
            ],
          ],
        },
        layout: 'noBorders'
      },
    ]
  };

  docDefinition.content.push(
    {
      text: 'Thinking about retirement',
      margin: [0, 24, 0, 0],
      fontSize: 14,
      bold: true,
    },
    {
      text: 'Starting to think about retirement can feel daunting whatever age you are but it can help if you discuss it with your loved ones.',
      margin: [0, 6, 0, 12],
      fontSize: 9,
    }
  );

  surveyStore.checkboxOptions.slice(0, 2).forEach((item) => {
    docDefinition.content.push({
      margin: [0, 8, 0, 0],
      columns: [
        {
          svg: surveyStore.surveyResult.checkboxes[item.index] ? checkedSVG : uncheckedSVG,
          width: 19,
        },
        [
          {
            text: item.label,
            fontSize: 11,
            width: '*',
            margin: [8, 3, 0, 0],
          },
          {
            text: convertLinkToText(item.hint),
            fontSize: 9,
            width: '*',
            margin: [8, 3, 0, 0],
            color: '#595959',
          }
        ]
      ]
    });
  });

  docDefinition.content.push(
    {
      text: 'Decide when to retire',
      margin: [0, 24, 0, 12],
      fontSize: 14,
      bold: true,
    },
  );

  surveyStore.checkboxOptions.slice(2, 5).concat(surveyStore.checkboxOptions[16]).forEach((item) => {
    docDefinition.content.push({
      margin: [0, 8, 0, 0],
      columns: [
        {
          svg: surveyStore.surveyResult.checkboxes[item.index] ? checkedSVG : uncheckedSVG,
          width: 19,
        },
        [
          {
            text: item.label,
            fontSize: 11,
            width: '*',
            margin: [8, 3, 0, 0],
          },
          {
            text: convertLinkToText(item.hint),
            fontSize: 9,
            width: '*',
            margin: [8, 3, 0, 0],
            color: '#595959',
          }
        ]
      ]
    });
  });

  docDefinition.content.push(
    {
      text: 'Protect your future and your loved ones',
      margin: [0, 24, 0, 12],
      fontSize: 14,
      bold: true,
    },
  );

  surveyStore.checkboxOptions.slice(5, 11).forEach((item) => {
    docDefinition.content.push({
      margin: [0, 8, 0, 0],
      columns: [
        {
          svg: surveyStore.surveyResult.checkboxes[item.index] ? checkedSVG : uncheckedSVG,
          width: 19,
        },
        [
          {
            text: item.label,
            fontSize: 11,
            width: '*',
            margin: [8, 3, 0, 0],
          },
          {
            text: convertLinkToText(item.hint),
            fontSize: 9,
            width: '*',
            margin: [8, 3, 0, 0],
            color: '#595959',
          }
        ]
      ]
    });
  });

  docDefinition.content.push(
    {
      text: 'An active retirement',
      margin: [0, 24, 0, 0],
      fontSize: 14,
      bold: true,
    },
    {
      text: 'Retirement is a big adjustment and it\'s natural to feel a bit lost or unsure of how to make the most of your new free time. There\'s no right or wrong way to spend retirement, but there are ways to make sure you\'re getting the most out of it.',
      margin: [0, 6, 0, 12],
      fontSize: 9,
    }
  );

  surveyStore.checkboxOptions.slice(11, 16).forEach((item) => {
    docDefinition.content.push({
      margin: [0, 8, 0, 0],
      columns: [
        {
          svg: surveyStore.surveyResult.checkboxes[item.index] ? checkedSVG : uncheckedSVG,
          width: 19,
        },
        [
          {
            text: item.label,
            fontSize: 11,
            width: '*',
            margin: [8, 3, 0, 0],
          },
          {
            text: convertLinkToText(item.hint),
            fontSize: 9,
            width: '*',
            margin: [8, 3, 0, 0],
            color: '#595959',
          }
        ]
      ]
    });
  });

  docDefinition.content.push(
    {
      text: 'You can access this checklist online:',
      margin: [0, 32, 0, 0],
      fontSize: 9,
      color: '#595959',
    },
    {
      qr: window.location.href,
      fit: 160,
      margin: [0, 6, 0, 0],
      foreground: '#595959',
    },
    {
      text: `© Co-operative Group Limited. All rights reserved. - ${window.location.hostname}`,
      margin: [0, 12, 0, 0],
      fontSize: 9,
      color: '#595959',
    },
  );

  // save as pdf
  pdfMake.createPdf(docDefinition).download('retirement-checklist.pdf');
};

// on load component update swiperInvolved
onMounted(() => {
  setTimeout(() => {
    swiperInvolved.value.swiper.update();
  }, 100);
});
</script>

<style scoped>
.ssn-ac-menu ul li a {
  font-weight: 500;
  color: var(--color-text-alt);
}

.ssn-footer-legal {
  padding-block-start: 0;
  border-top: 0;
}

.no-print {
  @media print {
    display: none !important;
  }
}

.pull-up {
  order: -1;
}

.coop-c-checklist-buttons {
  display: flex;
  gap: 24px;
}
</style>

<style>
a {
  @media print {
    color: currentColor;
  }
}

.coop-u-hide {
  display: none !important;
}
</style>
